import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ERROR_GRAPH__base } from './ERROR_GRAPH__base';

export class ERROR_GRAPH__graph extends ERROR_GRAPH__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.ERROR_GRAPH_GRAPH;

  /*
   * STATIC METHODS
   */
  static create(type: ENUM__error_type, graph_id: string = ENUM__string_id_empty.UUID) {
    let out = new ERROR_GRAPH__graph();

    out.type = type;
    out.graph_id = graph_id;

    return out;
  }

  /*
   * FIELDS
   */
  graph_id!: string;

  /*
   * METHODS
   */

  override is_equals(other: ERROR_GRAPH__base): boolean {
    if (!super.is_equals(other)) return false;
    if (!(other instanceof ERROR_GRAPH__graph)) return false;

    return other.graph_id == this.graph_id;
  }
}
